import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../modules/actions/authActions";
class NavBar extends React.Component {
  logout(e) {
    e.preventDefault();
    this.props.logout();
  }
  render() {
    const { isAuthenticated, user } = this.props.auth;
    return (
        <nav className="navbar navbar-expand-lg fixed-top custom-nav sticky">
          <div className="container-fluid">
            <Link to="/" className="logo navbar-brand desktop-logo">
              <img
                  src="/images/logo.svg"
                  alt=""
                  className="img-fluid logo-light"
              />
              <img
                  src="/images/logo-dark.svg"
                  alt=""
                  className="img-fluid logo-dark"
              />
            </Link>
            <Link to="/" className="logo navbar-brand mobile-logo">
              <img
                  src="/images/logo-m.svg"
                  alt=""
                  className="img-fluid logo-light"
              />
              <img
                  src="/images/logo-m.svg"
                  alt=""
                  className="img-fluid logo-dark"
              />
            </Link>
            <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
              <i className="mdi mdi-menu" />
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav ml-auto navbar-center" id="mySidenav">
                {/* <li className="nav-item active-">
                <Link to="/" className="nav-link">
                  How It Works
                </Link>
              </li> */}
                {/*<li className="nav-item">
                <Link to="/newpricing" className="nav-link hot">
                  Rate Plan
                </Link>
              </li>*/}

                <li className="nav-item">
                  <Link to="/" className="nav-link ">
                    Home
                  </Link>
                </li>
                {/*<li className="nav-item">
                <Link to="/buy/esim" className="nav-link buy">
                  Buy eSim
                </Link>
              </li>*/}
                <li className="nav-item">
                  <Link to={{ pathname: "https://mightyesim.com/" }} target="_blank" className="nav-link buy">
                    eSim
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/buy/device" className="nav-link buy">
                    Buy Device
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/recharge/device" className="nav-link">
                    Buy Data
                  </Link>
                </li>
                {/*<li className="nav-item">
                  <Link to="/buy-sim" className="nav-link">
                    Buy Sim
                  </Link>
                </li>*/}
                <li className="nav-item">
                  <Link to="/rent" className="nav-link rent">
                    Rental
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/activate" className="nav-link">
                    Device Activation
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/sale" className="nav-link ">
                    Sales
                  </Link>
                </li>
                {/*<li className="nav-item">
                  <Link to="/connect" className="nav-link ">
                    Business Partner
                  </Link>
                </li>*/}
                {/*<li className="nav-item">
                <Link to="/get-sim" className="nav-link">
                  Get Sim
                </Link>
              </li>*/}
                {isAuthenticated ? (
                    <ul className="navbar-nav ml-auto navbar-center">
                      <li className="nav-item">
                        <Link to="/dashboard" className="nav-link">
                          My Account
                        </Link>
                      </li>

                      <li className="nav-item">
                        <a
                            href="javascript:void(0)"
                            className="nav-link"
                            onClick={this.logout.bind(this)}
                        >
                          Sign Out
                        </a>
                      </li>
                    </ul>
                ) : (
                    <ul className="navbar-nav ml-auto navbar-center">
                      <li className="nav-item">
                        <Link to="/login" className="nav-link">
                          Sign In
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link to="/signup" className="nav-link">
                          Sign Up
                        </Link>
                      </li>
                    </ul>
                )}

                {/*<li className="nav-item">
                <Link to="/pricing" className="nav-link">/
                  PRICING
                </Link>
              </li>*/}

              </ul>
              <div>
                <ul className="text-right list-unstyled list-inline mb-0 social_menu">
                  <li className="list-inline-item">
                    <a href="https://twitter.com/mightywifi" target="_blank">
                      <i className="mdi mdi-twitter" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.instagram.com/themightywifi/" target="_blank">
                      <i className="mdi mdi-instagram" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.facebook.com/Mightywifi-101775645858664" target="_blank">
                      <i className="mdi mdi-facebook" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
    mapStateToProps,
    { logout }
)(NavBar);



// WEBPACK FOOTER //
// ./src/layout/NavBar.js